import { useState } from "react";

export const useForceUpdate = () => {
    const [, setValue] = useState<number>(0);
    return () => setValue(value => ++value);
};